import {
  useGetAppointmentsSearchDataOnMount,
  useSchedulingEnabled,
} from '@user/store/scheduling'
import { useSelector } from 'react-redux'
import { selectEntityAppointmentsSearch } from '@user/store/scheduling/searchSlice'
import { useMemo } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import {
  type IScheduleSettingsDetail,
  useSchedulingVisibility,
} from '@user/store/closingRequirements'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  scheduleSettings: IScheduleSettingsDetail
}

export function useHasScheduledAppointment(props: Props) {
  const { entityId, entityType, scheduleSettings } = props
  const schedulingEnabled = useSchedulingEnabled()
  const schedulingVisible = useSchedulingVisibility(scheduleSettings)
  const appointmentsSearch = useSelector(selectEntityAppointmentsSearch)

  const entityIds = useMemo(() => [entityId], [entityId])

  const appointmentsLoading = useGetAppointmentsSearchDataOnMount(
    entityIds,
    entityType === ENTITY_TYPES.Lead ? 1 : 0,
    schedulingEnabled && schedulingVisible,
  )

  return useMemo(
    () =>
      appointmentsLoading
        ? false
        : appointmentsSearch.some(
            (x) =>
              x.entityId === entityId &&
              x.status === 'Scheduled' &&
              x.workTime &&
              new Date(x.workTime) > new Date(),
          ) && schedulingEnabled,
    [appointmentsSearch, entityId, schedulingEnabled, appointmentsLoading],
  )
}
